import { PageInfo } from 'src/app/shared/models/queryparams/pageinfo.model';
import { SortInfo } from 'src/app/shared/models/queryparams/sortinfo.model';

export class TenantGridParams {
    pageInfo?: PageInfo;
    sortInfo?: SortInfo;
    searchText?: string;
}